export default {"src":"/_next/static/media/calendar.a187346f.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};